// 页面导出为pdf格式 //title表示为下载的标题，html表示document.querySelector('#myPrintHtml')
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import {
  Loading
} from 'element-ui'

export const htmlPdf = (title, imgElements) => {
  console.log(imgElements);
  let loading
  loading = Loading.service({
    lock: true,
    body: true,
    text: '报告导出中',
    spinner: 'el-icon-loading',
  });

  // 获取A4纸的尺寸（毫米）
  const A4_WIDTH = 210; // 宽度
  const A4_HEIGHT = 297; // 高度

  // 设置每张图片在A4纸上的宽度和高度（可以根据需要调整）
  const IMAGE_WIDTH = A4_WIDTH; // 图片宽度等于A4纸宽度
  const IMAGE_HEIGHT = (A4_HEIGHT / 2); // 图片高度为A4纸高度的一半，因为每页放两张图片

  const pdf = new JsPDF('p', 'mm', 'a4'); // 创建一个纵向的A4纸PDF

  // 遍历图片元素数组，每两个图片作为一对处理
  for (let i = 0; i < imgElements.length; i += 2) {
    const imgElement1 = imgElements[i];
    const imgElement2 = imgElements[i + 1] || null; // 如果图片数量为奇数，则第二个元素为null

    // 创建一个临时的div容器来包裹这两张图片（虽然这里我们直接对图片操作，但为保持结构清晰，可以这样做）
    // 实际上，我们可以直接对imgElements[i]和imgElements[i+1]进行操作

    // 使用Promise.all来等待两个html2canvas的异步操作完成
    Promise.all([
      html2Canvas(imgElement1, {
        scale: IMAGE_WIDTH / imgElement1.clientWidth, // 根据图片原始宽度和目标宽度计算缩放比例
        useCORS: true, // 允许跨域图片渲染
        allowTaint: false, // 不允许画布被污染（如果需要导出图像数据）
        scale: 2 // 按比例增加分辨率
      }),
      imgElement2 ? html2Canvas(imgElement2, {
        scale: IMAGE_WIDTH / imgElement2.clientWidth, // 同样计算缩放比例
        useCORS: true,
        allowTaint: false, // 不允许画布被污染（如果需要导出图像数据）
        scale: 2 // 按比例增加分辨率
      }) : Promise.resolve(null) // 如果imgElement2不存在，则返回一个已解决的Promise
    ]).then(([canvas1, canvas2]) => {
      // 获取Canvas内容并转换为图片数据
      const imgData1 = canvas1.toDataURL('image/png');
      const imgData2 = canvas2 ? canvas2.toDataURL('image/png') : null;
      // 将图片添加到PDF中
      pdf.addImage(imgData1, 'PNG', 0, 0, IMAGE_WIDTH, IMAGE_HEIGHT); // 添加第一张图片

      if (imgData2) {
        pdf.addImage(imgData2, 'PNG', 0, IMAGE_HEIGHT, IMAGE_WIDTH, IMAGE_HEIGHT); // 添加第二张图片
      }

      // 如果还有剩余的图片对，则添加新的PDF页面
      if ((i + 2) < imgElements.length) {
        pdf.addPage(); // 添加新页面
      }

      // 如果所有图片都已处理完毕，则保存PDF（这里使用了一个延迟来确保所有页面都已添加）
      if (i === imgElements.length - 2) {
        setTimeout(() => {
          pdf.save(title + '.pdf') // 保存PDF文件
          loading.close();
        }, 0); // 使用setTimeout来确保所有异步操作都已完成（虽然在这个例子中可能不是必需的，但为了保险起见）
      }
    }).catch(error => {
      console.error('Error converting HTML to PDF:', error);
      loading.close();
    });
  }

}